import { displayError } from '@ems/client-design-system';
import { IAudioLanguageData } from './interfaces';

export class BufferLoader {
  context: any;
  source: any;
  sourceList: any;
  onload: any;
  bufferList: any;
  loadCount: any;

  constructor(context: any, source: any, callback: any) {
    this.context = context;
    this.source = source;
    this.sourceList = Object.keys(source);
    this.onload = callback;
    this.bufferList = {};
    this.loadCount = 0;
  }

  loadBuffer = async (url: string, index: number, languageData: IAudioLanguageData) => {
    let arrayBuffer: ArrayBuffer;
    try {
      const response = await fetch(url);
      arrayBuffer = await response.arrayBuffer();
    } catch {
      displayError({
        message: languageData.loadError,
        timeout: 3000,
      });
      return;
    }

    try {
      const buffer = await this.context.decodeAudioData(arrayBuffer);
      this.bufferList[index] = {
        id: this.source[index].id,
        buffer,
      };
      if (++this.loadCount === this.sourceList.length) {
        this.onload(this.bufferList);
      }
    } catch {
      displayError({
        message: languageData.decodeError,
        timeout: 3000,
      });
    }
  };

  load = (languageData: IAudioLanguageData) => {
    for (let i = 0; i < this.sourceList.length; ++i) {
      this.loadBuffer(this.source[i].uri, i, languageData);
    }
  };
}
